import React from "react";
import { Layout, Space, Spin, Tag, Menu, Card, Empty, message } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  LineChartOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { UserButton } from "@clerk/clerk-react";
import Profile from "./profiles/Profile";
import { TokenConsumer } from "../TokenContext";
import { apiCallPost } from "./fns/util";
import ProfileList from "./profiles/ProfileList";
import SubmissionList from "./submissions/SubmissionList";
import PaperSubmissionForm from "./submissions/Paper";
import PosterSubmissionForm from "./submissions/Poster";
import VideoSubmissionForm from "./submissions/Video";
import ICSubmissionForm from "./submissions/InstructionCourse";
import OSWBLogo from "./OSWB-Logo.png";
import StatDash from "./StatDash";
import SchedulerLayout from "./scheduler/SchedulerLayout";
import InviteDelegate from "./profiles/InviteDelegate";
const { Header, Sider, Content } = Layout;

class CustomLayout extends React.Component {
  state = {
    isError: false,
    errorMessage: "",
    checkedIfFirstTime: false,
    isLoadingFirstTimeDetails: false,
    oswbUserPayload: null,
    isFirstTime: false,
    whichComponentToRender: null,
    loggedInUser: null,
    isAdmin: false,
    name: "",
    delegatePayload: null,
    submissionPayload: null,
  };
  getToken = async (provideToken, userEmail) => {
    let token = await provideToken();
    this.checkIfFirstTime(token, userEmail);
  };
  checkIfFirstTime = async (token, userEmail) => {
    if (!this.state.checkedIfFirstTime) {
      try {
        const res = await apiCallPost(
          token,
          "/conference2023/isFirstTimeLogin",
          {}
        );
        if (res) {
          this.setState(
            {
              isFirstTime: res,
              checkedIfFirstTime: true,
              isLoadingFirstTimeDetails: true,
            },
            () => this.fetchMyDetailsFromOSWB(token, userEmail)
          );
        } else {
          this.setState(
            {
              isFirstTime: false,
              checkedIfFirstTime: true,
              isLoadingFirstTimeDetails: false,
            },
            () => {
              this.getMyDetails(token);
            }
          );
        }
      } catch (err) {
        console.log(err);
        this.setState({ isError: true });
      }
    }
  };
  fetchMyDetailsFromOSWB = async (token, userEmail) => {
    try {
      const res = await apiCallPost(
        token,
        "/conference2023/fetchMyDetailsFromOSWB",
        {}
      );
      if (res.message === "Found OSWB user") {
        this.setState({
          oswbUserPayload: res.oswb,
          isLoadingFirstTimeDetails: false,
          isError: false,
        });
      } else if (res.message === "No user found with this email") {
        this.setState({
          isLoadingFirstTimeDetails: false,
          oswbUserPayload: null,
          isError: false,
          errorMessage: `No user found with the email ${userEmail}.`,
        });
      } else if (res.message === "More than one user found with this email") {
        this.setState({
          isLoadingFirstTimeDetails: false,
          isError: true,
          errorMessage: `More than one user found with email ${userEmail}.`,
        });
      } else {
        this.setState({
          isLoadingFirstTimeDetails: false,
          isError: true,
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ isError: true });
    }
  };
  getMyDetails = async (token) => {
    try {
      let res = await apiCallPost(token, "/conference2023/getMyDetails", {});
      let delegate = res.delegate;
      this.setState(
        {
          loggedInUser: delegate,
          isAdmin: delegate.isAdmin,
          isVideoJudge: delegate.isVideoJudge,
          isOPCJudge: delegate.isOPCJudge,
          name: delegate.name,
        },
        () => {
          if (this.state.isAdmin) {
            this.setState({
              whichComponentToRender: "DASHBOARD",
            });
          } else {
            this.setState({
              whichComponentToRender: "MY_PROFILE",
            });
          }
        }
      );
    } catch (err) {
      message.error("We ran into an error. Please try again.");
      this.setState({
        isError: true,
      });
    }
  };
  formatMenuItem = (label, key, icon, children, type) => {
    return { key, icon, children, label, type };
  };
  componentToRender = (context) => {
    if (!this.state.whichComponentToRender) {
      return (
        <div>
          <Empty
            description={
              <span>Choose a menu option from the left to get started. </span>
            }
          ></Empty>
        </div>
      );
    }
    let maps = {
      DASHBOARD: <StatDash isAdmin={this.state.isAdmin} context={context} />,
      SCHEDULER: (
        <SchedulerLayout isAdmin={this.state.isAdmin} context={context} />
      ),
      MY_PROFILE: (
        <Profile
          key={
            this.state.delegatePayload
              ? `${this.state.delegatePayload._id}__${this.state.delegatePayload.updatedAt}`
              : `${this.state.loggedInUser._id}__${this.state.loggedInUser.updatedAt}`
          }
          mode="EDIT"
          loggedInUser={this.state.loggedInUser}
          preloadedData={
            this.state.delegatePayload
              ? this.state.delegatePayload
              : this.state.loggedInUser
          }
          isRegistering={false}
          isAdmin={this.state.isAdmin}
          context={context}
          onDelegateUpdate={(delegate) => {
            this.setState({
              delegatePayload: delegate,
            });
          }}
        />
      ),
      REGISTRATION: (
        <Profile
          key={
            this.state.delegatePayload
              ? `${this.state.delegatePayload._id}__${this.state.delegatePayload.updatedAt}`
              : `${this.state.loggedInUser._id}__${this.state.loggedInUser.updatedAt}`
          }
          mode="EDIT"
          loggedInUser={this.state.loggedInUser}
          preloadedData={
            this.state.delegatePayload
              ? this.state.delegatePayload
              : this.state.loggedInUser
          }
          isRegistering={true}
          isAdmin={this.state.isAdmin}
          context={context}
          onDelegateUpdate={(delegate) => {
            this.setState({
              delegatePayload: delegate,
            });
          }}
        />
      ),
      PROFILE_LIST: (
        <ProfileList
          mode="EDIT"
          preloadedData={this.state.loggedInUser}
          loggedInUser={this.state.loggedInUser}
          isAdmin={this.state.isAdmin}
          context={context}
          onSelect={(delegate) => {
            this.setState({
              whichComponentToRender: "MY_PROFILE",
              delegatePayload: delegate,
            });
          }}
        />
      ),
      CREATE_DELEGATE: (
        <InviteDelegate
          mode="EDIT"
          preloadedData={this.state.loggedInUser}
          isAdmin={this.state.isAdmin}
          context={context}
          onSelect={(delegate) => {
            this.setState({
              whichComponentToRender: "MY_PROFILE",
              delegatePayload: delegate,
            });
          }}
        />
      ),
      SUBMISSION_LIST: (
        <SubmissionList
          mode="EDIT"
          preloadedData={this.state.loggedInUser}
          isAdmin={this.state.isAdmin}
          isVideoJudge={this.state.isVideoJudge}
          isOPCJudge={this.state.isOPCJudge}
          context={context}
          onNew={(submission) => {
            this.setState({
              whichComponentToRender: submission.submissionType,
              submissionPayload: submission,
            });
          }}
          onSelect={(submission) => {
            this.setState({
              whichComponentToRender: submission.submissionType,
              submissionPayload: submission,
            });
          }}
        />
      ),
      VIDEO_SUBMISSION_LIST: (
        <SubmissionList
          prefilter="VIDEO"
          mode="EDIT"
          preloadedData={this.state.loggedInUser}
          isAdmin={this.state.isAdmin}
          isVideoJudge={this.state.isVideoJudge}
          isOPCJudge={this.state.isOPCJudge}
          context={context}
          onNew={(submission) => {
            this.setState({
              whichComponentToRender: submission.submissionType,
              submissionPayload: submission,
            });
          }}
          onSelect={(submission) => {
            this.setState({
              whichComponentToRender: submission.submissionType,
              submissionPayload: submission,
            });
          }}
        />
      ),
      OPC_SUBMISSION_LIST: (
        <SubmissionList
          prefilter="OPC"
          mode="EDIT"
          preloadedData={this.state.loggedInUser}
          isAdmin={this.state.isAdmin}
          isVideoJudge={this.state.isVideoJudge}
          isOPCJudge={this.state.isOPCJudge}
          context={context}
          onNew={(submission) => {
            this.setState({
              whichComponentToRender: submission.submissionType,
              submissionPayload: submission,
            });
          }}
          onSelect={(submission) => {
            this.setState({
              whichComponentToRender: submission.submissionType,
              submissionPayload: submission,
            });
          }}
        />
      ),
      PAPER: (
        <PaperSubmissionForm
          key={
            this.state.submissionPayload &&
            `${this.state.submissionPayload._id}__${
              this.state.submissionPayload.updatedAt
            }__${new Date()}`
          }
          loggedInUser={this.state.loggedInUser}
          preloadedData={this.state.submissionPayload}
          isAdmin={this.state.isAdmin}
          context={context}
        />
      ),
      POSTER: (
        <PosterSubmissionForm
          key={
            this.state.submissionPayload &&
            `${this.state.submissionPayload._id}__${
              this.state.submissionPayload.updatedAt
            }__${new Date()}`
          }
          loggedInUser={this.state.loggedInUser}
          preloadedData={this.state.submissionPayload}
          isAdmin={this.state.isAdmin}
          context={context}
        />
      ),
      VIDEO: (
        <VideoSubmissionForm
          key={
            this.state.submissionPayload &&
            `${this.state.submissionPayload._id}__${
              this.state.submissionPayload.updatedAt
            }__${new Date()}`
          }
          loggedInUser={this.state.loggedInUser}
          preloadedData={this.state.submissionPayload}
          isAdmin={this.state.isAdmin}
          context={context}
        />
      ),
      IC: (
        <ICSubmissionForm
          key={
            this.state.submissionPayload &&
            `${this.state.submissionPayload._id}__${
              this.state.submissionPayload.updatedAt
            }__${new Date()}`
          }
          loggedInUser={this.state.loggedInUser}
          preloadedData={this.state.submissionPayload}
          isAdmin={this.state.isAdmin}
          context={context}
        />
      ),
    };
    return maps[this.state.whichComponentToRender];
  };
  render() {
    if (this.state.isError) {
      return (
        <div
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Tag color="red">
            We ran into an error: {this.state.errorMessage || "Please retry."}{" "}
            This email isn't associated with an OSWB Membership. Click below to
            sign-out and try a different email address
          </Tag>
          <UserButton />
        </div>
      );
    }
    return (
      <TokenConsumer>
        {(context) => {
          const { provideToken, userEmail } = context;
          this.getToken(provideToken, userEmail);
          if (!this.state.checkedIfFirstTime) {
            return (
              <div
                style={{
                  height: "100vh",
                  width: "100vw",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Spin size="large" />
                <br />
                <Tag color="blue">Loading</Tag>
              </div>
            );
          }
          if (this.state.isFirstTime) {
            if (this.state.isLoadingFirstTimeDetails) {
              return (
                <div
                  style={{
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Spin size="large" />
                  <br />
                  <Tag color="blue">Checking membership details...</Tag>
                </div>
              );
            }
            if (this.state.oswbUserPayload) {
              return (
                <div
                  style={{
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Profile
                    context={context}
                    mode="CREATE"
                    user="SELF"
                    preloadedData={this.state.oswbUserPayload}
                    onUpdate={(delegate) => {
                      this.setState(
                        { isFirstTime: false, loggedInUser: delegate },
                        () => {
                          this.getToken(provideToken, userEmail);
                        }
                      );
                    }}
                  />
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Profile
                    context={context}
                    mode="CREATE"
                    user="NON_MEMBER_SIGN_UP"
                    preloadedData={{
                      email: userEmail,
                      full_name: "",
                      phone: "",
                    }}
                    onUpdate={(delegate) => {
                      this.setState(
                        { isFirstTime: false, loggedInUser: delegate },
                        () => {
                          this.getToken(provideToken, userEmail);
                        }
                      );
                    }}
                  />
                </div>
              );
            }
          }
          let menuOptions = [
            this.formatMenuItem("My Profile", "MY_PROFILE", <UserOutlined />),
            this.formatMenuItem(
              "Registration",
              "REGISTRATION",
              <UserOutlined />
            ),
          ];
          if (this.state.isVideoJudge) {
            menuOptions.push(
              this.formatMenuItem(
                "Judge Video Submissions",
                "VIDEO_SUBMISSION_LIST",
                <UnorderedListOutlined />
              )
            );
          }
          if (this.state.isOPCJudge) {
            menuOptions.push(
              this.formatMenuItem(
                "Judge OPC",
                "OPC_SUBMISSION_LIST",
                <UnorderedListOutlined />
              )
            );
          }
          if (this.state.isAdmin) {
            menuOptions.push(
              this.formatMenuItem(
                "Dashboard",
                "DASHBOARD",
                <LineChartOutlined />
              )
            );
            menuOptions.push(
              this.formatMenuItem(
                "Delegate List",
                "PROFILE_LIST",
                <TeamOutlined />
              )
            );
            menuOptions.push(
              this.formatMenuItem(
                "Create Delegate",
                "CREATE_DELEGATE",
                <TeamOutlined />
              )
            );
            menuOptions.push(
              this.formatMenuItem(
                "Scheduler",
                "SCHEDULER",
                <CalendarOutlined />
              )
            );
          }
          if (
            (this.state.loggedInUser && this.state.loggedInUser.isOSWBMember) ||
            this.state.isAdmin
          ) {
            menuOptions.push(
              this.formatMenuItem(
                "Submissions",
                "SUBMISSION_LIST",
                <UnorderedListOutlined />
              )
            );
          }
          return (
            <Layout style={{ height: "100vh" }}>
              <Sider breakpoint="lg" collapsedWidth="0" collapsible={true}>
                <Space
                  direction="vertical"
                  size="large"
                  style={{
                    padding: "10px",
                    zIndex: "1000",
                    width: "100%",
                    height: "100vh",
                    justifyContent: "space-between",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ marginTop: "100px" }}>
                    <Menu
                      theme="dark"
                      onClick={(e) =>
                        this.setState({
                          whichComponentToRender: e.key,
                          delegatePayload: null,
                        })
                      }
                      block
                      mode="inline"
                      items={menuOptions}
                    />
                  </div>

                  <Space
                    direction="horizontal"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <UserButton />
                  </Space>
                </Space>
              </Sider>
              <Layout>
                <Header style={{ color: "white" }}>
                  <Space
                    direction="horizontal"
                    size="large"
                    style={{
                      padding: "10px",
                      width: "100%",
                      height: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      flexDirection: "row",
                      color: "white",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ height: "50px" }}>
                      <img
                        src={OSWBLogo}
                        alt="OSWB Logo"
                        style={{ height: "100%" }}
                      />
                    </div>
                    <div>OSWB Annual Conference</div>
                    <div
                      style={{
                        marginLeft: "10px",
                        color: "wheat",
                        fontSize: "small",
                      }}
                    >
                      {this.state.name} {this.state.isAdmin ? " | Admin" : ""}
                    </div>
                  </Space>
                </Header>
                <Content
                  style={{
                    height: "100vh",
                    overflowY: "scroll",
                    overflowX: "scroll",
                  }}
                >
                  <Card
                    style={{
                      padding: "5px",
                      margin: "auto",
                      maxWidth: "100%",
                    }}
                  >
                    {this.componentToRender(context)}
                  </Card>
                </Content>
              </Layout>
            </Layout>
          );
        }}
      </TokenConsumer>
    );
  }
}

export default CustomLayout;
